<template>
    <!-- @keydown.enter.prevent="submitForm" -->
    <div method="post" @submit.prevent="submitForm" @keydown="keydownForm">
        <section :class="'section section-calculator bg-grey nopadd ' + this.calculatorlayout">

            <div class="container">
                <div class="calculator-container">
                    <!-- START calculator -->
                    <div class="calculator">

                        <div class="calc-switches nav" role="tablist" v-if="settings.strom || settings.gas">
                            <button :class="(tarifTyp == 'strom' ? 'active' : '') +' calc-switch cs-strom'" data-toggle="pill" type="button" role="tab" aria-controls="calc-strom" :aria-selected="tarifTyp == 'strom'" v-if="settings.strom" name="btnStrom" @click="changeTarifTyp('strom')" tabindex="0" aria-label="Ökostrom">
                                <span class="cs-label">Ökostrom</span>
                            </button>
                            <button :class="(tarifTyp == 'gas' ? 'active' : '') +' calc-switch cs-erdgas'" data-toggle="pill" type="button" role="tab" aria-controls="calc-erdgas" :aria-selected="tarifTyp == 'gas'" v-if="settings.gas" name="btnGas" @click="changeTarifTyp('gas')" tabindex="0" aria-label="Erdgas">
                                <span class="cs-label">Erdgas</span>
                            </button>
                        </div>

                        <div class="select-consumption visible">
                            <div class="calc-form-label-group">
                                <label for="inputVerbrauch">Verbrauch *</label>
                                <input type="text" id="inputVerbrauch" class="form-control" placeholder="Verbrauch" :value="inputVerbrauch" @input="e => setVerbrauch(e.target.value, true)" min="100" @change="$emit('direktrechnen', {verbrauch: $event.target.value, plz: plz})" @focusin="showDropdown(true)" @focusout="blurVerbrauch($event)" tabindex="0" autocomplete="new-password" aria-describedby="inputVerbrauch-error">
                                <div id="inputVerbrauch-error" class="invalid-feedback">Bitte geben Sie den Verbrauch an.</div>
                            </div>
                        </div>

                        <!-- START calculator dropdown -->
                        <div class="calculator-dropdown cd-strom" v-show="dropdownVerbrauch && tarifTyp == 'strom'" role="listbox"><!-- hidden/visible -->
                            <div class="calc-options">

                                <div
                                    v-for="(verbrauch, vbindex) in settings.verbrauchswerte[settings.commoditymap.strom]"
                                    :class="'co-option option-' + vbindex + (parseInt(inputVerbrauch) === (cbDurchlauferhitzer ? verbrauch.durchlauferhitzer : verbrauch.wert) ? ' selected' : '')"
                                    @click="setVerbrauch(cbDurchlauferhitzer ? verbrauch.durchlauferhitzer : verbrauch.wert, true)"
                                    @focusin="showDropdown(true)"
                                    :key="vbindex"
                                    :tabindex="0"
                                    @keydown.enter="setVerbrauch(cbDurchlauferhitzer ? verbrauch.durchlauferhitzer : verbrauch.wert, true)"
                                    role="option"
                                    @focusout="blurVerbrauch($event)"
                                    :aria-label="verbrauch.wert + ' kWh'"
                                >
                                    <span class="value-1"><strong>{{ cbDurchlauferhitzer ? verbrauch.durchlauferhitzer : verbrauch.wert }}</strong>&nbsp;kWh</span>
                                    <span class="pic" :style="((verbrauch.bildurl) ? 'background-image: url(' + verbrauch.bildurl +'); background-size: contain;' : '')"></span>
                                </div>

                            </div>
                            <div class="co-check">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="cbDurchlauferhitzer" v-model="cbDurchlauferhitzer" tabindex="0" role="option" @focusout="blurVerbrauch($event)">
                                    <label class="custom-control-label" for="cbDurchlauferhitzer">Durchlauferhitzer vorhanden</label>
                                </div>
                            </div>
                        </div>
                        <!-- END calculator dropdown -->

                        <!-- START calculator dropdown -->
                        <div class="calculator-dropdown cd-erdgas" v-show="dropdownVerbrauch && tarifTyp == 'gas'" role="listbox"><!-- hidden/visible -->
                            <div class="calc-options">

                                <div
                                    :class="'co-option option-' + vbindex"
                                    @click="clickVerbrauch"
                                    @keydown.enter="clickVerbrauch"
                                    v-for="(verbrauch, vbindex) in settings.verbrauchswerte[settings.commoditymap.gas]"
                                     :key="vbindex"
                                    :tabindex="0"
                                    role="option"
                                    @focusout="blurVerbrauch($event)"
                                    :aria-label="verbrauch.wert + ' kWh'"
                                >
                                    <span class="value-1"><strong>{{ verbrauch.wert }}</strong>&nbsp;kWh</span>
                                    <span class="value-2">{{ verbrauch.groesse }}&nbsp;m<sup>2</sup></span>
                                    <span class="pic" :style="((verbrauch.bildurl) ? 'background-image: url(' + verbrauch.bildurl +'); background-size: contain;' : '')"></span>
                                </div>

                            </div>
                        </div>
                        <!-- END calculator dropdown -->
                        <div class="select-zipcode visible">
<!--                            <input type="search" name="testort" id="testort" autocomplete="on" />-->
    <!--                        <v-select autocomplete="address-level2" :options="['Dortmund', 'Schwerte']" />-->



                            <div class="calc-form-label-group">
                                <label :for="'vPlzAndCity' + this.settings.rid">PLZ, Stadt *</label>
                                <v-select :options="addressSuggestions" :id="'inputPlz'" :class="'form-control ' + (this.plz == '' ? '' : 'vs--selected')" placeholder="PLZ, Stadt" @open="$emit('focusPlzAndCity')" :value="plzAndCity" @search="$emit('searchPlzAndCity', $event)" @input="$emit('setPlzAndCity', $event)" @close="$emit('focusoutPlzAndCity')" autocomplete="off" :inputId="'vPlzAndCity' + this.settings.rid" :selectOnTab="true" :tabindex="0" :aria-describedby="'vPlzAndCity' + this.settings.rid + '-error'">
                                    <template #spinner="{ loading }">
                                        <div
                                            v-if="loading"
                                            style="border-left-color: rgba(88, 151, 251, 0.71)"
                                            class="vs__spinner"
                                        >
                                        </div>
                                    </template>
                                    <template slot="no-options">
                                        Bitte PLZ eingeben
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        {{ option.label }}
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        {{ option.label }}
                                    </template>
                                </v-select>

                                <div :id="'vPlzAndCity' + this.settings.rid + '-error'" class="invalid-feedback">Bitte geben Sie die PLZ an.</div>
                            </div>
                        </div>

                        <button id="calc-button" class="calc-button" type="submit" v-on:click="$emit('tarifeAnzeigen', {verbrauch: inputVerbrauch, plzAndCity: plzAndCity, strasse: strasse, hnr: hnr, hnrzusatz: hnrzusatz})" tabindex="0" aria-label="Tarife anzeigen">Tarife anzeigen</button>

                        <div class="select-street" v-show="addresscheck && showSecondLine"><!-- hidden/visible -->
                            <div class="calc-form-label-group">
                                <label :for="'inputStrasse'">Straße *</label>
                                <v-select :options="strassen" :id="'inputStrasse'" :class="'form-control' + (strasse !='' ? ' filled' : '')" placeholder="Straße" :value="strasse" @search="$emit('searchStrasse', $event)" @input="$emit('setStrasse', $event);" autocomplete="off" :inputId="'vstrasse' + this.settings.rid" @open="$emit('focusStrasse')" @close="$emit('focusoutStrasse')" :tabindex="0"  aria-describedby="inputStrasse-error" :selectOnTab="true">
                                    <template #spinner="{ loading }">
                                        <div
                                            v-if="loading"
                                            style="border-left-color: rgba(88, 151, 251, 0.71)"
                                            class="vs__spinner"
                                        >
                                        </div>
                                    </template>
                                    <template slot="no-options">
                                        Bitte Straße eingeben
                                    </template>
                                    <template slot="option" slot-scope="option">
                                            {{ option.label }}
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                            {{ option.label }}
                                    </template>
                                </v-select>

                                <div id="inputStrasse-error" class="invalid-feedback">Bitte geben Sie die Straße an.</div>
                            </div>
                        </div>

                        <div class="select-streetnumber" v-show="addresscheck && showSecondLine"><!-- hidden/visible -->
                            <div class="calc-form-label-group">
                                <label for="inputAddressHausnummer">Hausnr.*</label>
                                <input type="text" id="inputAddressHausnummer" class="form-control" placeholder="Hausnr." :value="hnr" @change="$emit('setHnr', $event.target.value)" tabindex="0" autocomplete="new-password"  ref="hausnummerRef" aria-describedby="inputAddressHausnummer-error">
                                <div id="inputAddressHausnummer-error" class="invalid-feedback">Bitte geben Sie die Hausnummer an.</div>
                            </div>
                        </div>

                        <div class="select-streetnumbersupplement" v-show="addresscheck && showSecondLine"><!-- hidden/visible -->
                            <div class="calc-form-label-group">
                                <label for="inputAddressHausnummerZ">Zusatz</label>
                                <input type="text" id="inputAddressHausnummerZ" class="form-control" placeholder="Zusatz" :value="hnrzusatz" @blur="$emit('setHnrzusatz', $event.target.value)" @keyup.enter="$emit('setHnrzusatz', $event.target.value)" tabindex="0" autocomplete="new-password" @focusin="focusHnrZusatz($event)" @focusout="focusHnrZusatz($event)">
                            </div>
                        </div>

                        <div class="calc-optional" v-html="settings.footertext" v-if="settings.footertext"></div>
                    </div>
                    <!-- END calculator -->



                </div>
            </div>

        </section>
    </div>
</template>

<script>
import $ from 'jQuery';
import Vue from 'vue';
import vSelect from 'vue-select';
// import 'vue-select/dist/vue-select.css';

Vue.component('v-select', vSelect);

export default {
    name: 'CRechner',
    props: {
        settings: {
            type: Object,
            default: () => {}
        },
        tarifTyp: {
            type: String,
            default: ''
        },
        // zweite Zeile soll nur angezeigt werden, wenn die Netzbetreibercodenummer nicht eindeutig ist,
        // da wir in diesem Falle weitere Informationen (Straße und Hausnummer) brauchen
        showSecondLine: {
            type: Boolean,
            default: false
        },
        addresscheck: {
            type: Boolean,
            default: true
        },
        strassen: {
            type: Array,
            default: () => []
        },
        strasse: {
            type: String,
            default: ''
        },
        plzAndCity: {
            type: Object,
            default: () => {}
        },
        hnr: {
            type: String,
            default: ''
        },
        hnrzusatz: {
            type: String,
            default: ''
        },
        stadt: {
            type: String,
            default: ''
        },
        plz: {
            type: String,
            default: ''
        },
        verbrauch: {
            type: String,
            default: ''
        },
        addressSuggestions: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            inputVerbrauch: 0,
            cbDurchlauferhitzer: false,
            dropdownVerbrauch: false,
            plzAndCityvalue: this.plzAndCity.value,
            plzAndCityvalueOld: ''
        }
    },
    mounted() {
        this.inputVerbrauch = this.verbrauch;
        document.addEventListener("click", this.handleClickOutsideVerbrauch);
    },
    computed: {
        calculatorlayout(){
            if(this.settings.layoutpreisrechner == '1') return 'calculator-stage';
            return 'calculator-inline';
        },
    },
    methods: {
        focusHnr: function(e){
            console.log('focusHnr', e);
            // $('#inputAddressHausnummer').focus();
            this.$refs.hausnummerRef.focus();
        },
        focusHnrZusatz: function(){
            // if($('#inputAddressHausnummer').val() == '') this.$refs.hausnummerRef.focus();

        },
        keydownForm: function(e){
            console.log('keydownForm', e);

            if(e.type == 'keydown'){
                if(e.key == 'Enter')
                {
                    if($(e.srcElement).attr('id') == 'cbDurchlauferhitzer'){
                        e.preventDefault();
                        if($(e.srcElement).is(':checked')) this.cbDurchlauferhitzer = false;
                        else this.cbDurchlauferhitzer = true;
                    }
                    else if($(e.srcElement).attr('id') == 'vstrasse' + this.settings.rid){
                        // this.$emit('setFocusHausnummer');
                        this.focusHnr();
                    }
                }
                // else if(e.key == 'Tab')
                // {
                //     if($(e.srcElement).attr('id') == 'vstrasse' + this.settings.rid){
                //         this.focusHnr();
                //     }
                // }
            }
        },
        submitForm: function (e) {
            // this.$emit('tarifeAnzeigen', {verbrauch: this.inputVerbrauch, plzAndCity: this.plzAndCity, strasse: this.strasse, hnr: this.hnr, hnrzusatz: this.hnrzusatz});

            if($(e.srcElement).prop('tagName') == 'FORM') return false;

            if (e instanceof KeyboardEvent){
                if(e.key == 'Enter' && e.code == 'Enter' && e.type =='keydown' && $(e.srcElement).attr('id') == 'calc-button' && $(e.target).attr('id') == 'calc-button')
                    return true;
            }
            return false;
        },
        showDropdown: function(e){
            this.dropdownVerbrauch = e;

            if(window.headroom !== undefined) window.headroom.freeze();

            if(e) {

                // let scrollPos = $('.calculator-container').offset().top - window.headroom.offset;
                // if($('header').hasClass('slideDown')) scrollPos = $('.calculator-container').offset().top - $('header').height();

                // let scrollPos = $('.calculator-container').offset().top - 300 - $('header').height();
                let scrollPos = $('.calculator-container').offset().top - 100 - $('header').height();

                if ($(window).scrollTop() > scrollPos) {
                    // window.headroom.freeze();

                    $('html, body').animate({scrollTop: scrollPos}, {duration : '500', complete: function (){
                            // if($('header').hasClass('slideDown')) scrollPos = $('.calculator-container').offset().top - 300 - $('header').height();
                            // $('html, body').animate({scrollTop: scrollPos}, {duration : '0'});
                        }});
                }
            }
            return e;
        },
        setVerbrauch(verbrauch, closeVerbrauchDropdown=false) {
            verbrauch = '' + verbrauch;
            this.inputVerbrauch = verbrauch;
            this.$emit('setVerbrauch', this.inputVerbrauch);
            this.$emit('setValid', '#inputVerbrauch');
            if (closeVerbrauchDropdown) {
                this.showDropdown(false);
            }
        },
        clickVerbrauch: function(e){
            let elm = $(e.target);

            // Workaround falls nicht das korekte Element getroffen wurde
            if(!$(elm).hasClass('co-option')) {
                elm = $(elm).parents('.co-option');
            }

            $('.co-option.selected').removeClass('selected');
            $(elm).addClass('selected');

            let verbrauchclass = 'span.value-1:not(.durchlaufeh) strong';
            if(this.cbDurchlauferhitzer && this.tarifTyp == 'strom') verbrauchclass = 'span.value-1.durchlaufeh strong';

            this.inputVerbrauch = $(elm).find(verbrauchclass).text();
            this.$emit('setVerbrauch', this.inputVerbrauch);

            if(this.cbDurchlauferhitzer) this.inputVerbrauch = (parseInt(this.inputVerbrauch) + parseInt(this.settings.rechner.durchlauferhitzerval)).toString();
            this.showDropdown(false);
            this.$emit('setValid', '#inputVerbrauch');
        },
        blurVerbrauch: function(e = null){
            // zurück Navigation rechts nach links kommend
            if($(e.srcElement).hasClass('co-option') && $(e.relatedTarget).attr('id') == 'inputVerbrauch')
            {
                this.dropdownVerbrauch = false;
                $('.calc-switch').focus();
                return;
            }

            if($(e.relatedTarget).hasClass('co-option')
                        || $(e.relatedTarget).attr('id') == 'cbDurchlauferhitzer'
                        || $(e.srcElement).attr('id') == 'inputVerbrauch'
            )
            {
                if($(e.relatedTarget).attr('type') == 'button'){
                    if(this.tarifTyp == 'strom') $('#cbDurchlauferhitzer').focus();
                    else $('.co-option:last').focus();
                }

                this.dropdownVerbrauch = true;
                return;
            }

            if($(e.srcElement).attr('id') == 'cbDurchlauferhitzer' && $(e.target).attr('id') == 'cbDurchlauferhitzer'){
                if(typeof e.relatedTarget !== "undefined" && e.relatedTarget !== null)
                {
                    if($(e.relatedTarget).attr('id').startsWith("vPlzAndCity")) {
                        this.dropdownVerbrauch = false;
                        return;
                    }
                }
                this.dropdownVerbrauch = true;
                return;
            }

                this.dropdownVerbrauch = false;
        },
        changeTarifTyp: function(e){
            this.$emit('changeTarifTyp', e);
        },
        handleClickOutsideVerbrauch(evt){
            if (!$(evt.target).hasClass('co-option')
                && $(evt.target).attr('id') != 'cbDurchlauferhitzer'
                && $(evt.target).attr('id') != 'inputVerbrauch'
                && $(evt.target).attr('for') != 'cbDurchlauferhitzer'
                && evt.target.tagName != 'MAIN') {
                this.showDropdown(false);
            }
        }
    },
    watch: {
        'dropdownVerbrauch': function() {
            if(window.headroom !== undefined) {
                if (this.dropdownVerbrauch) window.headroom.freeze();
                else window.headroom.unfreeze();
            }
        },
        cbDurchlauferhitzer: function(newVal, oldVal) {
            // Verbrauchswert anpassen, wenn Checkbox "Durchlauferhitzter" angepasst wurde

            const verbrauchOptions = Object.entries(this.tarifTyp === 'strom'
                ? this.settings.verbrauchswerte[1]
                : this.settings.verbrauchswerte[2]);

            // alte ausgewählte option suchen?
            const oldOption = verbrauchOptions.find(option => (oldVal ? option[1].durchlauferhitzer : option[1].wert) === parseInt(this.inputVerbrauch));

            if (oldOption) {
                const neuerVerbrauch = newVal ? oldOption[1].durchlauferhitzer : oldOption[1].wert
                neuerVerbrauch && this.setVerbrauch(neuerVerbrauch)
            }
        }
    }
}
</script>
